import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParceiroComponent } from './parceiro.component';
import { CadastroParceiroComponent } from './cadastro-parceiro/cadastro-parceiro.component';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { BaseListaModule } from 'src/app/utilities/base-lista/base-lista.module';
import { BotoesCadastroModule } from 'src/app/utilities/botoes-cadastro/botoes-cadastro.module';
import { GrupoModule } from 'src/app/utilities/grupo/grupo.module';
import { LabelModule } from 'src/app/utilities/label/label.module';
import { ToastModule } from 'primeng/toast';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { InputTextModule } from 'primeng/inputtext';
import { EnderecoModule } from 'src/app/utilities/endereco/endereco.module';



@NgModule({
  declarations: [
    ParceiroComponent,
    CadastroParceiroComponent
  ],
  imports: [
    CommonModule,
    BaseListaModule,
    FormsModule,
    BrowserModule,
    ConfirmDialogModule,
    GrupoModule,
    BotoesCadastroModule,
    TooltipModule,
    AccordionModule,
    LabelModule,
    ProgressBarModule,
    RippleModule,
    ToastModule,
    ScrollPanelModule,
    InputTextModule,
    EnderecoModule
  ],
  exports: [
    ParceiroComponent,
    CadastroParceiroComponent
  ],
})
export class ParceiroModule { }
